export default __webpack_public_path__ + "static/media/quote-mark.86875e0c.svg";